// extracted by mini-css-extract-plugin
export default {"mainCont":"SimCommon_mainCont__oqaV+","flexCenter":"SimCommon_flexCenter__YR0u6","btnCont":"SimCommon_btnCont__4Y+Q4"};